import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-btn-nuevo-tipo-comprobante',
  templateUrl: './btn-nuevo-tipo-comprobante.component.html',
  styleUrls: ['./btn-nuevo-tipo-comprobante.component.css']
})
export class BtnNuevoTipoComprobanteComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
